// extracted by mini-css-extract-plugin
export default {"contact":"contact_contact__WYRYC","card":"contact_card__9xEkA","section":"contact_section__bxcZ0"};